import axios from "axios";
export const initSideMenuChat = async () => {
    // チャット一覧ページの場合は chat.ts を使う
    const app = document.querySelector("#app");
    if (app !== null)
        return;
    // ユーザーIDの取得
    const userInfo = JSON.parse(document.querySelector("#left-menu-user-id")?.innerHTML || "{}");
    if (!userInfo.userId)
        return;
    const dispUnreadCount = async () => {
        let response = null;
        try {
            response = await axios.post("/api/u/mypage/chat/count/get", { userId: userInfo.userId });
        }
        catch (error) {
            window.console.error(error);
        }
        const span = document.getElementById("side-menu-chat-unread-count");
        if (!span)
            return;
        if (response.data.unread_count > 0) {
            span.innerHTML = response.data.unread_count.toString();
        }
    };
    await dispUnreadCount();
};
